import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { repTempActionTypes } from '../actions/reportTemplateActionTypes';

const ReportTemplateReducer = (state = { ...basicListAddEditDltInitialState, gridList: [{ data: [] }] }, action = null) => {
  switch (action.type) {
    case repTempActionTypes.SET_REPORT_TEMP_DATASOURCE_FEILD_RESPONSE: {
      return {
        ...state,
        dataSourceFields: action.data,
      };
    }
    case repTempActionTypes.SS_SAVE_UPDATE_TEMP_RESPONSE: {
      return {
        ...state,
        upsertData: action.data,
      };
    }
    case repTempActionTypes.SS_RESET_REPORT_TEMPLATE: {
      return {
        ...state,
        upsertData: null,
        dataSourceFields: [],
      };
    }
    case repTempActionTypes.GET_REPORT_TEMP_TEMPLATE_RESPONSE:
    case repTempActionTypes.GET_REPORT_TEMP_LIST_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case repTempActionTypes.GET_REPORT_TEMP_GRIDLIST_RESPONSE:
      return {
        ...state,
        gridList: action.data,
      };
    case commonTypes.RESETSTORE:
      return basicListAddEditDltInitialState;
    default:
      return state;
  }
};

export default ReportTemplateReducer;
